import { useEffect } from 'react';
import { Button } from './form';

interface ModalProps {
    open: boolean;
    onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
    onClose: () => void;
    header?: React.ReactNode;
    children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ open, onClick, onClose, header, children }) => {
    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [open]);

    if (!open) return null;

    return (
        <div className='fixed inset-0 z-[10000] hidden items-center justify-center bg-black/50 data-[open=true]:flex' data-open={open} onClick={onClick}>
            <div
                className='relative flex min-w-[320px] max-w-[90vw] flex-col items-start gap-4 rounded-[4px] bg-night-black p-8 text-ash-grey max-h-[80vh] overflow-y-auto'
                onClick={(e) => e.stopPropagation()}
            >
                <div className='mb-6 flex w-full items-center justify-between'>
                    {header && <div className='text-xl font-bold text-ash-grey'>{header}</div>}
                    <Button onClick={onClose} className='absolute right-4 top-4 cursor-pointer !bg-transparent'>
                        &times;
                    </Button>
                </div>
                <div className='w-full'>{children}</div>
            </div>
        </div>
    );
};

export default Modal;
